// extracted by mini-css-extract-plugin
export default {"login":"Auth_login__pOnHH","text":"Auth_text__+AbmY"};